import api from "../../services/api";
import {
  ADD_QUIZ_FAILURE,
  ADD_QUIZ_REQUEST,
  ADD_QUIZ_SUCCESS,
  CLEAR_QUIZ_ERRORS,
  DELETE_ALL_QUIZZES_FROM_CHAPTER_REQUEST,
  DELETE_ALL_QUIZZES_FROM_CHAPTER_SUCCESS,
  DELETE_ALL_QUIZZES_FROM_CHAPTER_FAILURE,
  UPSERT_QUIZZES_FOR_CHAPTER_REQUEST,
  UPSERT_QUIZZES_FOR_CHAPTER_SUCCESS,
  UPSERT_QUIZZES_FOR_CHAPTER_FAILURE,
  GET_QUIZZES_BY_CHAPTER_REQUEST,
  GET_QUIZZES_BY_CHAPTER_SUCCESS,
  GET_QUIZZES_BY_CHAPTER_FAILURE,
  GET_QUIZZES_BY_CHAPTER_ID_FAILURE,
  GET_QUIZZES_BY_CHAPTER_ID_REQUEST,
  GET_QUIZZES_BY_CHAPTER_ID_SUCCESS,
} from "./ActionType";

const addQuizRequest = () => ({
  type: ADD_QUIZ_REQUEST,
});

const addQuizSuccess = (payload) => ({
  type: ADD_QUIZ_SUCCESS,
  payload,
});

const addQuizFailure = (payload) => ({
  type: ADD_QUIZ_FAILURE,
  payload,
});

export const addQuiz = (chapterId, quizData) => async (dispatch) => {
  dispatch(addQuizRequest());
  try {
    const response = await api.post(`/chapters/${chapterId}/quizzes`, quizData);

    dispatch(addQuizSuccess(response.data));
  } catch (error) {
    dispatch(addQuizFailure(error.response.data));
  }
};

const getQuizzesByChapterIdRequest = () => ({
  type: GET_QUIZZES_BY_CHAPTER_ID_REQUEST,
});

const getQuizzesByChapterIdSuccess = (payload) => ({
  type: GET_QUIZZES_BY_CHAPTER_ID_SUCCESS,
  payload,
});

const getQuizzesByChapterIdFailure = (payload) => ({
  type: GET_QUIZZES_BY_CHAPTER_ID_FAILURE,
  payload,
});

export const getQuizzesByChapterId = (chapterId) => async (dispatch) => {
  dispatch(getQuizzesByChapterIdRequest());
  try {
    const response = await api.get(`/chapters/${chapterId}/quizzes`);
    dispatch(getQuizzesByChapterIdSuccess(response.data));
  } catch (error) {
    dispatch(getQuizzesByChapterIdFailure(error.response.data));
  }
};

const deleteQuizRequest = () => ({
  type: "DELETE_QUIZ_REQUEST",
});

const deleteQuizSuccess = (payload) => ({
  type: "DELETE_QUIZ_SUCCESS",
  payload,
});

const deleteQuizFailure = (payload) => ({
  type: "DELETE_QUIZ_FAILURE",
  payload,
});

export const deleteQuizfromChapter =
  (quizId, chapterId) => async (dispatch) => {
    dispatch(deleteQuizRequest());
    try {
      const response = await api.delete(
        `/chapters/${chapterId}/quizzes/${quizId}`
      );
      dispatch(deleteQuizSuccess(response.data));
    } catch (error) {
      dispatch(deleteQuizFailure(error.response.data));
    }
  };

export const clearQuizErrors = () => ({
  type: CLEAR_QUIZ_ERRORS,
});

// Delete All Quizzes from Chapter Actions
const deleteAllQuizzesFromChapterRequest = () => {
  return {
    type: DELETE_ALL_QUIZZES_FROM_CHAPTER_REQUEST,
  };
};

const deleteAllQuizzesFromChapterSuccess = (chapterId) => {
  return {
    type: DELETE_ALL_QUIZZES_FROM_CHAPTER_SUCCESS,
    payload: chapterId,
  };
};

const deleteAllQuizzesFromChapterFailure = (error) => {
  return {
    type: DELETE_ALL_QUIZZES_FROM_CHAPTER_FAILURE,
    payload: error,
  };
};

export const deleteAllQuizzesFromChapter = (chapterId) => async (dispatch) => {
  dispatch(deleteAllQuizzesFromChapterRequest());
  try {
    const response = await api.delete(`/chapters/${chapterId}/quizzes`);
    console.log("Delete All Quizzes from Chapter API Response:", response.data);
    
    if (response.data.success) {
      // Use the chapterId as the payload since the API returns nested data structure
      dispatch(deleteAllQuizzesFromChapterSuccess(chapterId));
    } else {
      dispatch(deleteAllQuizzesFromChapterFailure(response.data.message || "Failed to delete all quizzes from chapter"));
    }
  } catch (error) {
    console.error("Delete All Quizzes from Chapter API Error:", error.response?.data || error.message);
    dispatch(deleteAllQuizzesFromChapterFailure(error.response?.data || error.message));
  }
};

// Upsert Quizzes for Chapter Actions
const upsertQuizzesForChapterRequest = () => {
  return {
    type: UPSERT_QUIZZES_FOR_CHAPTER_REQUEST,
  };
};

const upsertQuizzesForChapterSuccess = (chapterId) => {
  return {
    type: UPSERT_QUIZZES_FOR_CHAPTER_SUCCESS,
    payload: chapterId,
  };
};

const upsertQuizzesForChapterFailure = (error) => {
  return {
    type: UPSERT_QUIZZES_FOR_CHAPTER_FAILURE,
    payload: error,
  };
};

export const upsertQuizzesForChapter = (chapterId, quizzesData) => async (dispatch) => {
  dispatch(upsertQuizzesForChapterRequest());
  try {
    const response = await api.put(`/chapters/${chapterId}/quizzes`, quizzesData);
    console.log("Upsert Quizzes for Chapter API Response:", response.data);
    
    if (response.data.success) {
      // Use the chapterId as the payload since the API returns nested data structure
      dispatch(upsertQuizzesForChapterSuccess(chapterId));
    } else {
      dispatch(upsertQuizzesForChapterFailure(response.data.message || "Failed to update quizzes for chapter"));
    }
  } catch (error) {
    console.error("Upsert Quizzes for Chapter API Error:", error.response?.data || error.message);
    dispatch(upsertQuizzesForChapterFailure(error.response?.data || error.message));
  }
};

// Get Quizzes by Chapter Actions
const getQuizzesByChapterRequest = () => {
  return {
    type: GET_QUIZZES_BY_CHAPTER_REQUEST,
  };
};

const getQuizzesByChapterSuccess = (quizzes) => {
  return {
    type: GET_QUIZZES_BY_CHAPTER_SUCCESS,
    payload: quizzes,
  };
};

const getQuizzesByChapterFailure = (error) => {
  return {
    type: GET_QUIZZES_BY_CHAPTER_FAILURE,
    payload: error,
  };
};

export const getQuizzesByChapter = (chapterId) => async (dispatch) => {
  console.log("getQuizzesByChapter called with chapterId:", chapterId);
  dispatch(getQuizzesByChapterRequest());
  try {
    const response = await api.get(`/chapters/${chapterId}/quizzes`);
    console.log("Get Quizzes by Chapter API Response:", response);
    console.log("Response data:", response.data);
    console.log("Response data.data:", response.data.data);
    console.log("Response data.data.quizzes:", response.data.data?.quizzes);
    
    if (response.data.success) {
      const quizzes = response.data.data?.quizzes || [];
      console.log("Dispatching success with quizzes:", quizzes);
      dispatch(getQuizzesByChapterSuccess(quizzes));
    } else {
      console.log("API returned success: false, message:", response.data.message);
      dispatch(getQuizzesByChapterFailure(response.data.message || "Failed to fetch quizzes for chapter"));
    }
  } catch (error) {
    console.error("Get Quizzes by Chapter API Error:", error);
    console.error("Error response:", error.response);
    dispatch(getQuizzesByChapterFailure(error.response?.data || error.message));
  }
};
